import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  initialState,
  NewClientData
} from '@/modules/sales/clients/store/clientSlice/initialState.ts'
import {
  Article,
  DeliveryArticle
} from '@/modules/sales/clients/types/Article.ts'

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    setIsCreateClientModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateClientModalOpen = action.payload
    },
    setIsEditClientModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEditClientModalOpen = action.payload
    },
    setIsEditClientEmailModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEditClientEmailModalOpen = action.payload
    },
    setIsEditClientPhoneModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEditClientPhoneModalOpen = action.payload
    },
    setIsEditClientReferralCodeModalOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isEditClientReferralCodeModalOpen = action.payload
    },
    setIsCreateUserForClientModalOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isCreateUserForClientModalOpen = action.payload
    },
    setSelectedClientId: (state, action: PayloadAction<string | null>) => {
      state.selectedClientId = action.payload
    },
    setShouldOpenAssignArticleOnSelect: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.shouldOpenAssignArticleOnSelect = action.payload
    },
    setClientFilters: (state, action: PayloadAction<string>) => {
      state.clientFilters = action.payload
    },
    setNewClientData: (state, action: PayloadAction<NewClientData>) => {
      state.newClientData = action.payload
    },
    setIsReassignModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isReassignModalOpen = action.payload
    },
    setIsDeliveryModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isDeliveryArticleModalOpen = action.payload
      if (!action.payload) {
        state.deliveryArticle = null
      }
    },
    setSelectedClientArticleId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.selectedClientArticleId = action.payload
    },
    setSelectedClientArticle: (
      state,
      action: PayloadAction<Article | null>
    ) => {
      state.selectedClientArticle = action.payload
      state.selectedClientArticleId = action.payload?.creditId || null
    },
    setIsChangeArticleModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isChangeArticleModalOpen = action.payload
    },
    setDeliveryArticle: (
      state,
      action: PayloadAction<DeliveryArticle | null>
    ) => {
      state.deliveryArticle = action.payload
    },
    reset: () => initialState
  }
})

export const clientActions = clientSlice.actions
export const { reducer: clientReducer } = clientSlice
